<template>
    <font-awesome-icon
        :icon="icon"
        :size="size"
        :spin="loading"
        :title="title"
        fixed-width
    />
</template>

<script>
// Components.
import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {far} from '@fortawesome/free-regular-svg-icons'
import {fas} from '@fortawesome/free-solid-svg-icons'

library.add(fas, far)

export default {
    components: {FontAwesomeIcon},
    props: {
        icon: {type: [String, Array], default: null},
        loading: {type: Boolean},
        size: {type: String},
        title: {type: String, default: ''},
    },
}
</script>